import React, { useEffect, Fragment } from 'react';
import './styles.scss';
import { noop } from '../../common/propTypes';
import ContentCard from '../../common/ContentCard';
import LoadingComponent from '../../common/LoadingComponent';
import PropTypes from 'prop-types';
import { getCurrentAndOldDate } from './utils';
import { LITTER_STATUS } from './constants';

function StatsCard({
    heading,
    data,
    isLoading,
    interval,
    fetchData,
    difference,
}) {
    useEffect(() => {
        const requestInterval = setInterval(() => {
            const { oldDate, currentDate } = getCurrentAndOldDate(difference);
            fetchData(oldDate, currentDate);
        }, interval);

        const { oldDate, currentDate } = getCurrentAndOldDate(difference);
        fetchData(oldDate, currentDate);

        return () => {
            clearInterval(requestInterval);
        };
    }, []);

    const mainContent = data && (
        <>
            <h3 className="stats-heading">Litter Uploaded</h3>
            <h1>{data.litters}</h1>
            <hr />
            <h3 className="stats-heading">New Users</h3>
            <h1>{data.users}</h1>
            {isLoading && (
                <div className="loader-parent">
                    <LoadingComponent isLoading={true} />
                </div>
            )}
            <table className="table table-striped">
                <thead>
                    <th>Progress</th>
                    <th>Count</th>
                </thead>
                <tbody>
                    {data.progress.map((progress) => (
                        <tr key={progress.progress}>
                            <td>{progress.progress}</td>
                            <td>{progress.count}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <hr />
            <div className="table-parent">
                <table className="table table-striped">
                    <thead>
                        <th>Code</th>
                        <th>Status</th>
                        <th>Count</th>
                    </thead>
                    <tbody>
                        {data.status.map((element) => (
                            <tr key={element.status}>
                                <td style={{ width: '20%' }}>
                                    {element.status}
                                </td>
                                <td style={{ fontSize: '12px' }}>
                                    {LITTER_STATUS[String(element.status)]}
                                </td>
                                <td>{element.count}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <hr />
            <div className="table-parent">
                <table className="table table-striped">
                    <thead>
                        <th>Country Code</th>
                        <th>Litter</th>
                    </thead>
                    <tbody>
                        {data.countries.map((country) => (
                            <tr key={country.country}>
                                <td>{country.country}</td>
                                <td>{country.count}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </>
    );

    return (
        <Fragment>
            <ContentCard heading={heading} content={mainContent} />
        </Fragment>
    );
}

StatsCard.propTypes = {
    heading: PropTypes.string,
    data: PropTypes.object,
    isLoading: PropTypes.bool,
    error: PropTypes.string,
    interval: PropTypes.number.isRequired,
    fetchData: PropTypes.func,
    difference: PropTypes.number,
};

StatsCard.defaultProps = {
    heading: '',
    data: {
        countries: [],
        litters: '',
        users: '',
        progress: [],
    },
    isLoading: false,
    error: '',
    fetchData: noop,
    difference: 360 * 60 * 1000, // 6 hours
};

export default StatsCard;
